/*
  Rayı gerçek satış sırasına dizer.

  Neden gerekli: Liquid bir koleksiyonu kendisi sıralayamıyor, yalnızca
  koleksiyonun panelde tanımlı sırasını okuyabiliyor. Parfüm
  koleksiyonlarının sırası manuel olduğu için "Çok satanlar" rayı gerçek
  satış sırasını göstermiyordu.

  Nasıl: collection.adp-bs şablonundan yalnızca sıralı ürün adreslerini
  çekiyoruz (birkaç yüz bayt), sonra karteleri o sıraya diziyoruz.
  Sayfada olmayan ürün eklenmiyor — yalnızca var olanlar yeniden
  sıralanıyor, yani stok filtresi bozulmuyor.

  Koleksiyonun sıralaması panelden "En çok satan" yapılırsa bu betik
  hiçbir şey değiştirmez; ray zaten doğru sırayla basılmış olur.
*/
(function () {
  'use strict';

  var raylar = document.querySelectorAll('[data-adp-bs]');
  if (!raylar.length) return;

  Array.prototype.forEach.call(raylar, function (ray) {
    var handle = ray.getAttribute('data-adp-bs');
    if (!handle) return;

    fetch('/collections/' + encodeURIComponent(handle) + '?view=adp-bs&sort_by=best-selling', {
      headers: { 'X-Requested-With': 'fetch' }
    })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) {
        if (!t) return;
        var sira;
        try { sira = JSON.parse(t.trim()); } catch (e) { return; }
        if (!Array.isArray(sira) || !sira.length) return;

        var ogeler = {};
        Array.prototype.forEach.call(ray.children, function (li) {
          var h = li.getAttribute('data-handle');
          if (h) ogeler[h] = li;
        });

        // Sıradaki her ürünü, sayfada varsa sona taşı. Kalanlar
        // (sırada geçmeyenler) mevcut hâlleriyle en sonda kalır.
        var tasindi = 0;
        sira.forEach(function (h) {
          var li = ogeler[h];
          if (li) { ray.appendChild(li); tasindi++; }
        });

        if (tasindi) ray.setAttribute('data-adp-bs-uygulandi', String(tasindi));
      })
      .catch(function () { /* sıralama alınamazsa panel sırası kalır */ });
  });
})();
